import {FC, lazy} from 'react';

const toDefault =
  (key: string) =>
  ({[key]: component}: Record<string, FC>) => ({default: component});

const Account = lazy(() => import('../../ui/views/Account').then(toDefault('Account')));
const Login = lazy(() => import('../../ui/views/Login').then(toDefault('Login')));
const MyLookiero = lazy(() => import('../../ui/views/MyLookiero').then(toDefault('MyLookiero')));
const PlacedOrder = lazy(() => import('../../ui/views/MyLookiero/PlacedOrder').then(toDefault('PlacedOrder')));
const TrackingOrder = lazy(() => import('../../ui/views/MyLookiero/TrackingOrder').then(toDefault('TrackingOrder')));
const CheckoutPreview = lazy(() =>
  import('../../ui/views/MyLookiero/Checkout').then(({Checkout}) => ({default: Checkout})),
);
const ResetPassword = lazy(() => import('../../ui/views/ResetPassword').then(toDefault('ResetPassword')));
const ReferralsSummary = lazy(() =>
  import('../../ui/views/Referrals/ReferralsSummary').then(toDefault('ReferralsSummary')),
);
const Referrals = lazy(() => import('../../ui/views/Referrals/Referrals').then(toDefault('Referrals')));
const LookIn = lazy(() => import('../look-in/ui/views/LookIn').then(toDefault('LookIn')));
const PublicReturnOrder = lazy(() => import('../../ui/views/PublicReturnOrder').then(toDefault('PublicReturnOrder')));
const Support = lazy(() => import('../support/ui/views/Support').then(toDefault('Support')));
const ProfileMenu = lazy(() => import('../../ui/views/ProfileMenu/ProfileMenu').then(toDefault('ProfileMenu')));
const Checkout = lazy(() => import('../checkout/ui/views/checkout/Checkout').then(toDefault('Checkout')));
const Quiz = lazy(() => import('../quiz/ui/views/quiz/Quiz').then(toDefault('Quiz')));
const QuizRegister = lazy(() =>
  import('../../ui/views/Style/QuizRegister/QuizRegister.view').then(toDefault('QuizRegisterView')),
);
const StyleProfile = lazy(() =>
  import('../styleProfile/ui/views/styleProfile/StyleProfile').then(toDefault('StyleProfile')),
);
const MyPlan = lazy(() => import('../../ui/views/Account/Plan/MyPlan').then(toDefault('MyPlan')));
const DeleteAccountInfo = lazy(() =>
  import('../../ui/views/DeleteAccount/DeleteAccountInfo').then(toDefault('DeleteAccountInfo')),
);
const DeleteAccountConfirm = lazy(() =>
  import('../../ui/views/DeleteAccount/DeleteAccountConfirm').then(toDefault('DeleteAccountConfirm')),
);
const DeleteAccountSuccess = lazy(() =>
  import('../../ui/views/DeleteAccount/DeleteAccountSuccess').then(toDefault('DeleteAccountSuccess')),
);
const DeleteAccountError = lazy(() =>
  import('../../ui/views/DeleteAccount/DeleteAccountError').then(toDefault('DeleteAccountError')),
);
const CancelBoxFlow = lazy(() => import('../../ui/views/CancelBox/CancelBoxFlow').then(toDefault('CancelBoxFlow')));

export {
  Account,
  Login,
  MyLookiero,
  PlacedOrder,
  TrackingOrder,
  CheckoutPreview,
  ResetPassword,
  ReferralsSummary,
  Referrals,
  LookIn,
  PublicReturnOrder,
  ProfileMenu,
  Checkout,
  Quiz,
  QuizRegister,
  StyleProfile,
  MyPlan,
  DeleteAccountInfo,
  DeleteAccountConfirm,
  DeleteAccountSuccess,
  DeleteAccountError,
  CancelBoxFlow,
  Support,
};

// Eager (not lazy): they only render a <Navigate>, so a Suspense fallback flash would be pointless.
export {SupportFaqsRedirect} from '../support/ui/views/SupportFaqsRedirect';
export {SupportAnonymousRedirect} from '../support/ui/views/SupportAnonymousRedirect';
